module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon6.png?2c14a6ae";